import { useContext, useEffect, useState } from "react";
import { Table, Card } from "antd";

import { Context } from "../../context";
import { Fetch } from "../../fetch";

import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

import "./styles.css";

const { Column } = Table;

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const AcquisitionMetrics = () => {
  const { token, apiUrl } = useContext(Context);
  const [sourcesData, setSourcesData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    Fetch(`${apiUrl}/reports/acquisition_reports`, token, (result) => {
      if (result.success) {
        setSourcesData(result.data);
        setLoading(false);
      }
    });
  }, [apiUrl, token]);

  return (
    <Card
      className="two-col-reports-wrapper"
      title={"Top Channels by acquisition"}
    >
      <Table dataSource={sourcesData} size="small" loading={loading}>
        <Column title="Channel" align="left" dataIndex={"channel"} />
        <Column title="Visitors" align="center" dataIndex={"visitors"} />
        <Column title="Subscribers" align="center" dataIndex={"subscribers"} />
        <Column
          title="Avg Watch time (in minutes)"
          align="center"
          dataIndex={"avg_watch_time"}
        />
      </Table>
    </Card>
  );
};

export default AcquisitionMetrics;
